/** Piece count/labels only — shared without pulling in jewelry or cart UI. */

export const MIN_PIECE_COUNT = 1;
export const MAX_PIECE_COUNT = 6;

/** @param {number} count */
export function defaultPieceLabels(count) {
  const n = Math.max(1, Math.min(MAX_PIECE_COUNT, count || 1));
  if (n === 2) return ['His', 'Hers'];
  return Array.from({ length: n }, (_, i) => `Piece ${i + 1}`);
}

/** @param {unknown} raw */
export function normalizePieceConfig(raw) {
  const src = raw && typeof raw === 'object' && !Array.isArray(raw) ? raw : {};
  const count = Math.max(
    MIN_PIECE_COUNT,
    Math.min(MAX_PIECE_COUNT, parseInt(String(src.count ?? ''), 10) || 1)
  );
  let labels = Array.isArray(src.labels)
    ? src.labels.map((l) => String(l || '').trim()).filter(Boolean)
    : [];
  const defaults = defaultPieceLabels(count);
  while (labels.length < count) {
    labels.push(defaults[labels.length] || `Piece ${labels.length + 1}`);
  }
  labels = labels.slice(0, count);
  return { count, labels };
}

/** @param {object} product */
export function getProductPieceConfig(product) {
  const raw = product?.customization_options?.pieceConfig;
  return normalizePieceConfig(raw || { count: 1 });
}

/** @param {object} product */
export function productMultiPieceEnabled(product) {
  return getProductPieceConfig(product).count > 1;
}
